<template>
  <div
    data-testid="template-preview-card"
    class="tw-flex tw-aspect-video tw-items-center tw-justify-center tw-bg-cover"
    :style="{
      background: eventBackground
    }"
  >
    <div
      class="tw-relative tw-mr-[4%] tw-h-[70%] tw-w-[60%] tw-rounded"
      :style="{
        background: stageBackground
      }"
    >
      <div
        class="tw-absolute tw-bottom-1 tw-left-1 tw-h-[8%] tw-w-[20%] tw-rounded"
        :style="{ background: pillColor }"
      />
    </div>
    <div
      class="tw-h-[70%] tw-w-[20%] tw-rounded"
      :style="{
        background: sidebarBackground
      }"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import { ThemeObj } from '@/studio/studioEventList/store/types';

export default defineComponent({
  name: 'ThemeMoodBoard',
  props: {
    themeObj: {
      type: Object as PropType<ThemeObj>,
      required: true
    }
  },
  computed: {
    eventBackground(): string {
      return this.themeObj.event_background;
    },
    pillColor(): string {
      return this.themeObj.theme_secondary_color;
    },
    stageBackground(): string {
      return this.themeObj.stage_background;
    },
    sidebarBackground(): string {
      return `rgba(${this.themeObj.primary_background_shade}, ${this.themeObj.sidebar_alpha})`;
    }
  }
});
</script>
